<div class="admin-stations">

  <sc-master-detail [selection]="[selectedStation]" [data]="stations" [newStyle]="true"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);">

    <div class="details-layout">
      <form #stationForm="ngForm" class="details-form">
        @if (selectedStation) {
          <app-station-details [station]="workingCopyDetails" [form]="stationForm">
          </app-station-details>
        }
      </form>
    </div>

    <ng-template masterDetailToolbar>
      <sc-cancel-button [disabled]="!cancelEnabled" (click)="cancel()"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary (click)="save()" [disabled]="!saveEnabled"></sc-save-button>
    </ng-template>

  </sc-master-detail>

</div>
